var map = {
	"./camara_ilhavo.svg": 821,
	"./coopernico.svg": 319,
	"./digitalmente.svg": 99,
	"./it.svg": 840,
	"./magnum_cap.svg": 792,
	"./s_salvador.svg": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 310;